import { AdrDto } from "@cradua/data";
import { environment } from "apps/epims/mrsoftepims/src/environments/environment";
import { HttpClient, HttpRequest, HttpEvent, HttpParams, HttpHeaders } from "@angular/common/http";

import { Injectable } from "@angular/core";
import { Observable } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class AdrService {
  url = `${environment.apiUrl}adrprogress`;
  constructor(private http: HttpClient) {}

  getAdr(): Observable<AdrDto[]> {
    return this.http.get<AdrDto[]>(this.url);
  }

  createAdr(data: AdrDto): Observable<AdrDto> {
    return this.http.post<AdrDto>(this.url, data);
  }
  getSingleAdr(id: string): Observable<any> {
    return this.http.get(this.url + "/" + id);
  }

  fetchAdr(query: any): Observable<AdrDto[]> {
    return this.http.post<AdrDto[]>(this.url + "/fetch", query);
  }

  fetchByIdAdr(id: any): Observable<AdrDto[]> {
    return this.http.post<AdrDto[]>(this.url + "/fetchById", {id});
  }

  updateAdr(data: AdrDto): Observable<AdrDto> {
    return this.http.post<AdrDto>(this.url + "/update", data);
  }

  deleteAdr(id: string) {
    return this.http.delete(this.url + "/" + id);
  }

  public uploadFile(
    file: File,
    data: any[],
    type: string,
  ): Observable<HttpEvent<{}>> {
    const formData = new FormData();
    formData.append("file", file, file.name);
    formData.append("Body", JSON.stringify(data));

    const options = {
      reportProgress: true,
    };

    const req = new HttpRequest(
      "POST",
      `${this.url + "gateway/createdocument?type=" + type}`,
      formData,
      options,
    );

    return this.http.request(req);
  }
}